import { writable, type Writable } from "svelte/store";
import { getContext, setContext } from "svelte";

const key = Symbol();

export const createSessionStore = (data: App.Locals["session"]) => {
  const session = writable<App.Locals["session"]>(data);
  setContext(key, session);
  return session;
};

export const sessionStore = (): Writable<App.Locals["session"]> =>
  getContext(key);
